import React, { useState } from 'react';
import axios from 'axios';

const API_URL = 'https://broadcastbackend.onrender.com/api';

export default function AccessModal({ onAccessGranted }) {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    country: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const submitWithRetry = async (retries = 2) => {
      try {
        await axios.post(`${API_URL}/submit/access`, formData, { timeout: 10000 });
        localStorage.setItem('tempesAccessGranted', 'true');

        setTimeout(() => {
          onAccessGranted();
        }, 600);
      } catch (err) {
        if (retries > 0) {
          // Retry after 2 seconds
          setTimeout(() => submitWithRetry(retries - 1), 2000);
        } else {
          setError('Unable to submit. Please try again.');
          setLoading(false);
        }
      }
    };

    submitWithRetry();
  };

  return (
    <div className="access-modal">
      <div className="access-modal-content">
        <div className="access-modal-header">
          <div className="logo">
            <span className="logo-icon">◆</span>
            <span className="logo-text">Tem<span>pes</span></span>
          </div>
          <h2>Welcome to Tempes</h2>
          <p>Please fill in your details to access our website</p>
        </div>

        {error && <div className="error-message">{error}</div>}

        <form className="access-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">Country</label>
            <input
              type="text"
              id="country"
              name="country"
              placeholder="Enter your country"
              value={formData.country}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="access-submit-btn" disabled={loading}>
            <span className="btn-text">
              {loading ? 'Submitting...' : 'Access Website'}
            </span>
            <i className="fa-solid fa-arrow-right"></i>
          </button>

          <p className="access-note">Your information will be sent securely to our support team.</p>
        </form>
      </div>
    </div>
  );
}
